export default __webpack_public_path__ + "static/media/kitchen3-afterC-768w.27f51e58.png";